import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

interface LetContext<T> {
    letVar: T;
}

@Directive({
    selector: "[letVar]",
})
export class LetDirective<T> {
    private _context: LetContext<T> = { letVar: null };

    constructor(
        _viewContainer: ViewContainerRef,
        _templateRef: TemplateRef<LetContext<T>>
    ) {
        _viewContainer.createEmbeddedView(_templateRef, this._context);
    }

    @Input()
    set letVar(value: T) {
        this._context.letVar = value;
    }
}
